import { jsx as _jsx } from "react/jsx-runtime";
import { pillStyling } from './styling';
export function Pill({ children, variant }) {
    return (_jsx("span", { className: pillStyling({ variant }), children: children }));
}
